import { defineStore } from 'pinia'
import { Message } from '../shared/models'

interface State {
  notify: Message
  isChargingBatteries: boolean
}

const useNotifications = defineStore({
  id: 'notificationStore',
  state: (): State => ({
    notify: {
      severity: 'success',
      summary: '',
      detail: '',
    },
    isChargingBatteries: false,
  }),
  actions: {
    addErrorNotification(notification: Message) {
      this.notify = {
        ...notification,
      }
    },
    addSuccesNotification(notificacion: Message) {
      this.notify = {
        ...notificacion,
      }
    },
    addInfoNotification(notificacion: Message) {
      this.notify = {
        ...notificacion,
      }
    },
    setLoadingState() {
      this.isChargingBatteries = true
    },
    dismissLoadingState() {
      this.isChargingBatteries = false
    },
  },
})

export default useNotifications
